export var RecordingStatus;
(function (RecordingStatus) {
    RecordingStatus["IN_PROGRESS"] = "in-progress";
    RecordingStatus["COMPLETED"] = "completed";
    RecordingStatus["FAILED"] = "failed";
})(RecordingStatus || (RecordingStatus = {}));
export var TranscriptionStatus;
(function (TranscriptionStatus) {
    TranscriptionStatus["COMPLETED"] = "completed";
    TranscriptionStatus["FAILED"] = "failed";
})(TranscriptionStatus || (TranscriptionStatus = {}));
export var AssistantStatus;
(function (AssistantStatus) {
    AssistantStatus["ACTIVE"] = "active";
    AssistantStatus["PROCESSED"] = "processed";
    AssistantStatus["COMPLETED"] = "completed";
    AssistantStatus["ERROR"] = "error";
})(AssistantStatus || (AssistantStatus = {}));
//# sourceMappingURL=conference.js.map